import styled from "styled-components";
import { Text } from "@smartsuite/react-ui/lib";
import { t } from "i18next";
import { GrayColors } from "@smartsuite/types";

export const WhereBtn: React.FC = () => {
  return (
    <Root>
      <Text
        size="xs"
        weight="semibold"
        color="secondary"
        transformMode="uppercase"
      >
        {t("general.where")}
      </Text>
    </Root>
  );
};

const Root = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;

  height: 36px;

  background: ${GrayColors["G-1"]};
  border-radius: 5px;

  text-transform: uppercase;
`;
